import { useEffect, useRef, useState } from 'react';

export const useTooltip = ({ duration = 2000 }: { duration?: number } = {}) => {
  const tooltipTimerRef = useRef<NodeJS.Timeout | null>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (tooltipTimerRef.current) {
      clearTimeout(tooltipTimerRef.current);
      tooltipTimerRef.current = null;
    }

    if (show) {
      tooltipTimerRef.current = setTimeout(() => {
        setShow(false);
      }, duration);
    }

    return () => {
      if (tooltipTimerRef.current) {
        clearTimeout(tooltipTimerRef.current);
        tooltipTimerRef.current = null;
      }
    };
  }, [show, duration]);

  return [show, setShow] as const;
};
